import { v4 as uuidv4 } from 'uuid';
import { scheduleReport } from './payrollReportsEnum';
import { renderClientName } from './constants';

export const roleManagementReport = () => {
    return {
        title: 'Role Management',
        url: '/reports/system/roles',
    };
};
export const permissionReport = () => {
    return {
        title: 'Permissions List',
        url: '/reports/system/permissions',
    };
};
export const deletedScheduleReport = () => {
    return {
        title: 'Deleted Appointment Detail Report',
        url: '/reports/appt/deleted',
        list: [
            {
                type: 'dos',
                startDate: 'deletedStartDate',
                endDate: 'deletedEndDate',
                startLabel: 'Deletion Start Date',
                endLabel: 'Deletion End Date',
                required: true,
            },
            {
                type: 'selectMultipleWidthPagination',
                name: 'clients',
                label: 'Client',
                reqType: 'client',
                renderValue: (option) => renderClientName(option),
            },
        ],
    };
};

export const systemReportEnums = [
    {
        id: uuidv4(),
        name: 'Role Management',
        description: 'Shows roles and their corresponding permissions with permission descriptions.',
        generateInfo: roleManagementReport(),
    },
    {
        id: uuidv4(),
        name: 'Permissions List',
        description: 'Shows all permissions in the system with their corresponding descriptions.',
        generateInfo: permissionReport(),
    },
    {
        id: uuidv4(),
        name: 'Deleted Appointment Detail Report',
        description:
            'Detailed overview of deleted appointments, including staff, client, billing, and service information. Optionally filter by client.',
        generateInfo: deletedScheduleReport(),
    },
];
